import gsap, { Power1, Power2, Power3, Power4, Expo, Back } from "gsap";

import { C, GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Metrics } from "../_app/cuchillo/core/Metrics";
import { Functions } from "../_app/cuchillo/utils/Functions";
import { Maths } from "../_app/cuchillo/utils/Maths";
import Footer from "./Footer";
import Header from "./Header";

export default class Preloader {
    _container;
    _words;
    _mainLogo = GetBy.id()

    static init() {
        this._container = GetBy.id('Preloader');
        this._mainLogo = GetBy.class("logo", Footer.container)[0];

        const temp = Functions.arrayRandom([...GetBy.class("holder", this._container)]);
        for(let i=1,j=temp.length;i<j;i++) {
            C.remove(temp[i]);
        }

        if (isDebug) this._container.style.display = "none";

        this._words = [...GetBy.class("__word", this._container)];
        const distance = Metrics.WIDTH * .007;
        for(let i = 0, j = this._words.length; i<j; i++) {


            let distance = Maths.maxminRandom(Metrics.WIDTH * .007, Metrics.WIDTH * .003);
            const offset = {
                x: Math.random() > .5? 1 : -1,
                y: Math.random() > .5? -1 : 1
            }
           // gsap.set(this._words[i],{x:offset.x * distance, y:offset.y * distance,force3D:true});

            gsap.set(this._words[i],{y:offset.y * distance * .2,force3D:true});
        }

        this.show();
    }

    static show() {
        //this._words = Functions.arrayRandom(this._words);
       
        for(let i = 0, j = this._words.length; i<j; i++) {
            
            gsap.to(this._words[i],{opacity:1, duration:.1, delay: i * .1, ease:Power2.easeIn});
            //gsap.to(this._words[i],{x:0, duration:.3, delay: .1 + i * .1, ease:Power3.easeOut});
            gsap.to(this._words[i],{y:0, duration:.1, delay: .1 + i * .1, ease:Power3.easeOut});
            
        }
    }

    static update(__progress) {
    }

    static hide(__call) {
        if (isDebug) {
            Header.showAlpha(0);
            gsap.to(this._mainLogo,{y:0, opacity:1, duration:.1});
            if (__call) __call();
            return;
        }

        const delay = 2;

        this._words = Functions.arrayRandom(this._words);
        this._logo = this._words.filter(word => word.querySelector('span'))[0];
        this._words = this._words.filter(word => !word.querySelector('span'));
        this._words.push(this._logo);

        for(let i = 0, j = this._words.length; i<j; i++) {
            let distance = Maths.maxminRandom(Metrics.WIDTH * .01, Metrics.WIDTH * .007);
            const offset = {
                x: Math.random() > .5? 1 : -1,
                y: Math.random() > .5 || i==j-1? -1 : 1
            }
            
            gsap.to(this._words[i],{x:offset.x * distance, duration:.3, delay: delay + 0.05 +  i * .05, ease:Power2.easeIn});
            gsap.to(this._words[i],{y:offset.y * distance, duration:.3, delay: delay + i * .05, ease:Power3.easeOut});
            
            const delayFinal = 0;//.2; 

            if(i == j-1) {
               
                gsap.set(this._mainLogo,{x:-offset.x * Metrics.WIDTH * .05});
                gsap.to(this._words[i],{opacity:0, duration:.01, delay: delay + .25 + i * .05, ease:Power4.easeIn, 
                    onStart:()=> {
                    
                   // gsap.to(this._logo,{y:-distance*3, duration:.6, delay:delayFinal + .1, ease:Back.easeIn});
                   // gsap.to(this._logo,{opacity:0, duration:.01, delay:delayFinal + .6, ease:Power3.easeIn});
                    
                    
                }});

                setTimeout(()=> {
                    gsap.to(this._mainLogo,{opacity:1, duration:.01, delay:delayFinal + .2, ease:Power3.easeIn});
                    
                    gsap.to(this._mainLogo,{
                        x:0,
                        duration:.8, 
                        delay:delayFinal + 0, 
                        ease:Expo.easeOut,
                    });
                    gsap.to(this._mainLogo,{
                        y:0,
                        duration:.5, 
                        delay:delayFinal + 0, 
                        ease:Expo.easeOut,
                        onStart:()=> {
                            
                        }
                    });
                     
                    
                    
                    gsap.to(this._container, {
                        duration: .1,
                        opacity: 0,
                        delay: delayFinal + .6,
                        onComplete: () => {
                            this._container.style.display = "none";
                            Header.showAlpha(0.6);
                           
                        }
                    });
                }, ( delay + i * .05 + .1) * 1000);

                setTimeout(()=> {
                    if (__call) __call();  
                }, ( delay + i * .05 - .2) * 1000);
            } else {
                gsap.to(this._words[i],{opacity:0, duration:.01, delay: delay + .25 + i * .05, ease:Power2.easeIn});
            }   
        }
        
    }
}
